document.addEventListener('keydown', function (event) {
  // Check if the Escape key is pressed
  if (event.key === 'Escape' || event.keyCode === 27) {
    // Check if both body and html have the cart popup open classes
    var bodyHasClasses = document.body.classList.contains('js-drawer-open') && document.body.classList.contains('js-drawer-open-right');
    var htmlHasClasses = document.documentElement.classList.contains('js-drawer-open') && document.documentElement.classList.contains('js-drawer-open-right');

    if (bodyHasClasses || htmlHasClasses) {
      // Remove the cart popup open classes from both body and html
      document.body.classList.remove('js-drawer-open', 'js-drawer-open-right');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-right');
      
      // Set focus back to the cart toggle button
      var cartToggle = document.querySelector('.site-header__cart-toggle');
      if (cartToggle) {
        cartToggle.focus();
      }

      // Re-attach event listener to the cart toggle button to ensure opening works
      cartToggle.addEventListener('click', function () {
        document.body.classList.add('js-drawer-open', 'js-drawer-open-right');
        document.documentElement.classList.add('js-drawer-open', 'js-drawer-open-right');
        
        // Re-attach close button functionality after opening
        reattachCloseButton();
      }, { once: true });
    }
  }
});

// Function to reattach the close button listener each time the popup is opened
function reattachCloseButton() {
  var closeButton = document.querySelector('.drawer__close');
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      // Remove the cart popup open classes from both body and html
      document.body.classList.remove('js-drawer-open', 'js-drawer-open-right');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-right');
      
      // Set focus back to the cart toggle button
      var cartToggle = document.querySelector('.site-header__cart-toggle');
      if (cartToggle) {
        cartToggle.focus();
      }
    });
  }
}

// Initially attach the close button listener
reattachCloseButton();


          // For Price Lable

document.addEventListener("DOMContentLoaded", function() {
  var existCondition = setInterval(function() {
    if (document.querySelector('.prod-desc')) {
      clearInterval(existCondition);
      runMyFunction2();
    }
  }, 500);

  function runMyFunction2() {
    console.log("Customer Email Loading");
    var salePriceElements = document.querySelectorAll('.prod-desc p strong');
    salePriceElements.forEach(function(el) {
      el.insertAdjacentHTML('afterbegin', '<span class="visually-hidden">Sale Price</span>');
    });

    var regularPriceElements = document.querySelectorAll('.prod-desc p s');
    regularPriceElements.forEach(function(el) {
      el.insertAdjacentHTML('afterbegin', '<span class="visually-hidden">Regular Price</span>');
    });
  }
});